module.exports = __webpack_public_path__ + "static/media/lock.298f811e.png";